module.exports = __webpack_public_path__ + "img/USD.04214bdc.png";